import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { CATEGORIES } from "./constants";
import { useTheme } from "@mui/material/styles";

export default function CategoriesSelector({ value = "Geral", onChange }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        width: "100%",
        overflowX: "auto",
        flexWrap: "nowrap",
        minWidth: 0,
        py: 0.5,
      }}
    >
      {CATEGORIES.map((cat) => {
        const isSelected = value === cat;

        return (
          <Button
            key={cat}
            size="small"
            onClick={() => onChange?.(cat)}
            sx={{
              flex: 1,
              flexShrink: 0,
              minWidth: 110,  
              minHeight: 28,
              fontSize: "12px",
              borderRadius: "15px",
              textTransform: "none",
              whiteSpace: "nowrap",
              backgroundColor: isSelected
                ? theme.palette.primary.main
                : theme.palette.custom.gray[300],
              color: "#fff",
              "&:hover": {
                backgroundColor: isSelected
                  ? theme.palette.primary.main
                  : theme.palette.custom.purple[400],
              },
            }}
          >
            {cat}
          </Button>
        );
      })}
    </Box>
  );
}